<template>
  <v-container>
    <apexchart
      type="radar"
      width="100%"
      height="322"
      :options="chart.options"
      :series="chart.series"
    ></apexchart>
  </v-container>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'RadarChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: [
    'chartData',
    'characterTypes',
  ],
  data() {
    return {
      chart: {
        type: 'radar',
        options: {
          plotOptions: {
            radar: {
              size: 100,
              offsetX: 0,
              offsetY: 0,
              polygons: {
                strokeColors: "#5E00BC",
                strokeWidth: 1,
                connectorColors: "#5E00BC",
                fill: {
                  color: "#5E00BC"
                }
              }
            }
          },
          fill: {
            opacity: 0.5,
            colors: ["#5E00BC"]
          },
          // チャートの動的な部分
          xaxis: {
            categories: this.chartData.map(function( value ) {
              if (this.length > 0) {
                let result = this.filter(function(characterType) {
                    return characterType.character_id == this.character_id;
                }, value);
                return result[0].name;
              }
              return value.name;
            }, this.characterTypes),
          }
        },
        series: [{
          name: '5段階中',
          // チャートの動的な部分
          data: this.chartData.map(function( value ) {
            return value.score;
          }),
        }],
      }
    }
  },
}
</script>
